export const projects = [
    {
        title: "Speculative, Superscalar & Out-of-Order CPU Simulator",
        github: true,
        link: "https://github.com/jade-bejide/superscalar-processor",
        tech_stack: ["Python"],
        descr: "CPU simulator with Advanced Computer Architecture features such as IEEE754 floating point and SIMD processing. Benchmarked performance on a range of mathematical and AI kernels such as integer differentiation and sigmoid perceptron."
    },
    // {
    //     title: "Unnamed Project",
    //     github: false,
    //     link: "",
    //     tech_stack: ["React Native", "FastAPI", "Python", "AWS S3", "Tailwind CSS"],
    //     descr: "Cross-platform social mobile application"
    // },
    {
        title: "Dream Journal",
        github: true,
        link: "https://github.com/jade-bejide/DreamJournalAPI",
        tech_stack: ["Python", "FastAPI", "JavaScript", "gensim", "nltk"],
        descr: "Uses a Latent Dirirchlet Allocation trained text model to infer the underlying emotion of a dream journal excerpt."
    },


    // {
    //     title: "Ephm3ralMusic",
    //     github: false,
    //     link: "https://jadesolabejide.dev/Ephm3ralMusic",
    //     tech_stack: ["Python", "FastAPI", "MySQL", "JavaScript"],
    //     descr: "(WIP) A social media app which recommends new music to users, based on who they follow, to expand their music taste. This project is temporarily idle while I look for a new MySQL hosting platform."
    // },
    {
        title: "Conway's Game of Life",
        github: true,
        link: "https://github.com/jade-bejide/2D-Cellular-Automata",
        tech_stack: ["C"],
        descr: "C Implementation of Conway's Game of Life"
    },
    {
        title: "Ephm3ralMusicAPI",
        github: true,
        link: "https://github.com/jade-bejide/Ephm3ralMusic-API",
        tech_stack: ["Python", "FastAPI", "MySQL"],
        descr: "A lightweight facade of the Spotify Web API. This project is temporarily idle while I look for a new MySQL hosting platform."
    },
    // {
    //     title: "Natural Sum",
    //     github: true,
    //     link: "https://github.com/jade-bejide/Natural-Sum",
    //     tech_stack: ["C", "POSIX"],
    //     descr: "A concurrent program which calculates the natural sum based on command-line arguments."
    // },
    {
        title: "Social Recommender System",
        github: true,
        link: "https://github.com/jade-bejide/Social-Recommender-System",
        tech_stack: ["Python", "MySQL", "GuiZero"],
        descr: "A movie recommendation system where collaborative filtering is limited to who a user follows."
    }
    

]

// {
//     title: "",
//     link: "",
//     tech_stack: [],
//     descr: ""
// }